/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Artcraft_PdfInputs */

const en_fc_home_artcraft_pdf = /** @type {(inputs: Fc_Home_Artcraft_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Fc_Home_Artcraft_PdfInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_artcraft_pdf = /** @type {((inputs?: Fc_Home_Artcraft_PdfInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Artcraft_PdfInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_artcraft_pdf(inputs)
});
export { fc_home_artcraft_pdf as "fc.home.artcraft.pdf" }